import "./AboutUs.scss";
import "../../components/AboutUs/About.scss";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import images from "../../constants/images";
import SubHeading from "../../components/SubHeading/SubHeading";
import Footer from "../../components/Footer/Footer";
import Team from "../../components/Team/Team";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import useTranslate from "../../hooks/useTranslate";

const AboutUs = () => {
  const { translate, language } = useTranslate();
  const layoutClass = language.startsWith("fa") ? "rtl-mode" : "ltr-mode";

  return (
    <div className="about-page">
      <Navbar />
      <div className={`app_aboutUs section__padding ${layoutClass}`}>
        <div className="app_aboutUs-image">
          <LazyLoadImage effect="blur" src={images.sketch} alt="sketch image" />
        </div>
        <div className="app_aboutUs-content">
          <SubHeading
            title={translate("aboutUs.title")}
            description={translate("aboutUs.desc")}
            kind={translate("aboutUs.kind")}
            color="#0c0c0c"
            spoonColor="black"
          />
          <p className="p__openSans" style={{ color: "#0c0c0c" }}>
            {translate("about.home.desc0")}
          </p>
          <p className="p__openSans" style={{ color: "#0c0c0c" }}>
            {translate("aboutUs1")}
          </p>
          <p className="p__openSans" style={{ color: "#0c0c0c" }}>
            {translate("about.home.desc1")}
          </p>
        </div>
      </div>
      <div className={`app_aboutUs section__padding ${layoutClass}`} id="about-us">
        <div className="app_aboutUs-content">
          <SubHeading
            title={translate("About.title")}
            description={translate("About.desc")}
            kind=""
            color="#0c0c0c"
            spoonColor="black"
          />
          <p className="p__openSans" style={{ color: "#0c0c0c" }}>
            {translate("aboutUs3")}
          </p>
        </div>
        <div className="app_aboutUs-image">
          <LazyLoadImage
            effect="blur"
            src={images.sketch2}
            alt="sketch image"
          />
        </div>
      </div>
      <Team />
      <Footer />
    </div>
  );
};
export default AboutUs;
